module.exports = __webpack_public_path__ + "static/media/feedback.a0fef61b.svg";